<template>
  <div class="d-flex">
    <div
      class="d-flex flex-column flex-grow"
      :class="{'w-50' : !searchStatus,'w-100':searchStatus }"
    >
      <div class="input-group">
        <input
          v-model="keyword"
          type="text"
          class="form-control"
          placeholder="Name / SKU"
          aria-label="search sku"
          aria-describedby="basic-addon2"
        >
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="search"
          >
            <i
              class="fi-search"
            />
          </button>
        </div>
      </div>
      <div
        v-if="searchStatus"
        class="h-100 flex-grow"
        style="overflow-y: auto;"
      >
        <div style="max-height: 500px">
          <table class="table table-hover table-product">
            <tr
              v-for="product in products"
              :key="product.id"
              :class="{'selected': product.sku == selectedProduct}"
              scope="row"
              @click="selectProduct(product)"
            >
              <td width="112">
                <img
                  class="thumb-lg"
                  :src="product.thumb"
                  alt=""
                >
              </td>
              <td>{{ product.name }} <br> <span class="text-muted">SKU: {{ product.sku }}</span></td>
            </tr>
          </table>
        </div>
      </div>
      <div
        v-if="searchStatus"
        class="d-flex"
      >
        <div class="flex-fill">
          <div
            class="btn-group"
            role="group"
            aria-label="paging"
          >
            <button
              :disabled="offset <= 0"
              type="button"
              class="btn btn-outline-secondary"
              @click="prevPage"
            >
              <i
                class="dripicons-chevron-left"
              />
            </button>
            <button
              :disabled="products.more == false"
              type="button"
              class="btn btn-outline-secondary"
              @click="nextPage"
            >
              <i
                class="dripicons-chevron-right"
              />
            </button>
          </div>
        </div>
        <div class="flex-fill text-right">
          <button
            class="btn btn-light mr-2"
            @click="cancelSearch"
          >
            Cancel
          </button>
          <button
            :disabled="selectedProduct == 0"
            class="btn btn-primary"
            @click="changeSku()"
          >
            Select
          </button>
        </div>
      </div>
      <div
        v-if="!searchStatus && skuInfo ==null"
        class="mt-3"
      >
        <div
          v-if="action=='edit'"
          class="alert alert-danger"
        >
          Invalid SKU.
        </div>
        <div
          v-if="action=='add'"
          class="alert alert-info"
        >
          Please select product.
        </div>
      </div>
      <div
        v-if="!searchStatus && skuInfo !=null"
        class="mt-3"
      >
        <div class="form-group">
          <label>Product</label> <br>
          <strong>{{ skuInfo.product.name }}</strong>
        </div>
        <div class="form-group">
          <label>SKU</label>
          <input
            v-model="data.sku"
            class="form-control"
            name="sku"
            required
          >
        </div>
        <div class="form-group">
          <label>Style</label>
          <select
            v-model="data.style"
            class="form-control"
            name="product_style"
          >
            <option
              v-for="s in skuInfo.styles"
              :value="s.name"
            >
              {{ s.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Size</label>
          <select
            v-model="data.size"
            class="form-control"
            name="product_size"
          >
            <option
              v-for="s in sizes"
              :key="s"
              :value="s"
            >
              {{ s }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Color</label>
          <select
            v-model="data.color"
            class="form-control"
            name="product_color"
          >
            <option
              v-for="c in colors"
              :key="c.name"
              :value="c.name"
            >
              {{ c.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Quantity</label>
          <input
            v-model="data.quantity"
            class="form-control"
            name="quantity"
            type="number"
            required
          >
        </div>
      </div>
    </div>

    <div
      v-show="!searchStatus"
      class="flex-fill ml-3 p-3 shipping"
    >
      <div class="form-group">
        <label>Order ID</label>
        <input
          v-model="data.order_id"
          class="form-control"
          name="order_id"
          required
        >
      </div>
      <div class="form-group">
        <label>Name</label>
        <input
          v-model="data.shipping_name"
          class="form-control"
          name="shipping_name"
          required
        >
      </div>
      <div class="form-group">
        <label>Address 1</label>
        <input
          v-model="data.shipping_address_1"
          class="form-control"
          name="shipping_address_1"
          required
        >
      </div>
      <div class="form-group">
        <label>Address 2</label>
        <input
          v-model="data.shipping_address_2"
          class="form-control"
          name="shipping_address_2"
          required
        >
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>City</label>
            <input
              v-model="data.shipping_city"
              class="form-control"
              name="shipping_city"
              required
            >
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>State</label>
            <input
              v-if="!getState() || getState().length ==0"
              v-model="data.shipping_state"
              class="form-control"
              name="shipping_state"
              required
            >
            <select
              v-if="getState() && getState().length >0"
              id="shipping_state"
              v-model="data.shipping_state"
              required
              class="form-control"
              name="shipping_state"
            >
              <option
                v-for="c in getState()"
                :key="c.code"
                :value="c.code"
              >
                {{ c.code + ' - ' + c.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Zipcode</label>
            <input
              v-model="data.shipping_zipcode"
              class="form-control"
              name="shipping_zipcode"
              required
            >
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Country</label>
            <select
              id="shipping_country"
              v-model="data.shipping_country"
              class="form-control"
              name="shipping_country"
            >
              <option
                v-for="c in country"
                :key="c.name"
                :value="c.name"
              >
                {{ c.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group">
        <button
          class="btn btn-success mr-3"
          @click="save"
        >
          Save
        </button>
        <button
          v-if="action =='edit'"
          class="btn btn-warning mr-3"
          @click="copy"
        >
          Clone
        </button>
        <button
          class="btn btn-light"
          @click="cancel"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ImportOrderForm",
        props: ['item', 'action'],
        data: function () {
            return {

                selectedProduct: 0,
                searchStatus: false,
                offset: 0,
                limit: 10,
                page: 1,
                keyword: '',
                last_keyword: '',
                products: {
                    items: [],
                    more: false,
                    end: false
                },
                design: {},
                tab: 'import',
                disable: 0,
                filter: {},
                orders: [],
                file: null,
                skuInfo: null,
                colors: [],
                sizes: [],
                country: [],
                data: {}
            }
        },
        watch: {
            'data.style': function (val) {
                console.log(val)
                if (val == null) return false
                if (val == '') return false
                this.getColor()
                this.getSize()
            },
            'data.sku': function () {
                this.skuInfo = null
                this.sku(this.data.sku)
            },
            'item': function () {
                this.data = this.$_.cloneDeep(this.item)
            }
        },

        mounted: function () {
            //    this.loadDesign()
            this.getCountry()
            this.data = this.$_.cloneDeep(this.item)
            this.sku(this.data.sku)

        },
        methods: {

            cancel: function () {
                this.$root.$emit('bv::hide::modal', 'modal-order-form', '#btnShow')
            },
            save: function () {

                this.data.validate = null

                if (this.colors.length == 0) {
                    this.data.color = ''
                }

                if (!this.sizes.length == 0) {
                    this.data.size = ''
                }

                if (this.action == 'add') {
                    this.$root.$emit('bv::hide::modal', 'modal-order-form', '#btnShow')
                    this.$emit('add', this.data)
                    return
                }

                this.$root.$emit('bv::hide::modal', 'modal-order-form', '#btnShow')
                this.$emit('update', this.data)
                //  this.item = this.data
            },
            copy: function () {

                this.data.validate = null
                if (this.colors.length == 0) {
                    this.data.color = ''
                }

                if (!this.sizes.length == 0) {
                    this.data.size = ''
                }

                this.$root.$emit('bv::hide::modal', 'modal-order-form', '#btnShow')
                this.$emit('add', this.data)
                return

                //  this.item = this.data
            },
            getState: function () {

                let state = this.$_.find(this.country, {name: this.data.shipping_country})
                if (state && state.region != undefined) return state.region
                return []
            },
            search: function () {
                this.searchStatus = true
                this.page = 1
                this.fetch()
            },
            fetch: function () {
                let vm = this

                let query = '?a=1';

                if (this.keyword != this.last_keyword) {
                    this.last_keyword = this.keyword
                    this.page = 1;
                    console.log('change keyword')
                }

                if (this.keyword != '') {
                    query += '&keyword=' + encodeURIComponent(this.keyword)
                }

                let offset = (this.page - 1) * this.limit
                this.offset = offset
                query += '&limit=' + this.limit
                query += '&offset=' + offset

                this.$http.get(this.$config.api + 'campaigns' + query).then(function (res) {
                    vm.products = res.data.results
                })
            },
            sku: function (sku) {
                let vm = this
                if (sku == '' || sku == null) return
                this.$http.get(this.$config.api + 'fulfillment/sku/' + sku).then(function (res) {
                    if (res.data.code && res.data.code == 404) {
                        vm.skuInfo = null
                        return false
                    }
                    vm.skuInfo = res.data

                    vm.getSize()
                    vm.getColor()
                });
            },
            selectProduct: function (item) {
                // console.log(item)
                this.selectedProduct = parseInt(item.sku)
            },
            cancelSearch: function () {
                this.searchStatus = false
                this.selectedProduct = 0
            },
            getColor: function () {
                //    console.log(this.data.style)
                try {
                    if (this.skuInfo.styles[this.data.style]) {
                        this.colors = this.skuInfo.styles[this.data.style].colors || []
                    }
                } catch (e) {

                }
            },
            getSize: function () {
                try {
                    if (this.skuInfo.styles[this.data.style]) {
                        this.sizes = this.skuInfo.styles[this.data.style].sizes || []
                    }
                } catch (e) {

                }
            },
            nextPage: function () {
                console.log('next')
                this.page = this.page + 1;
                this.fetch()
            },
            prevPage: function () {
                console.log('back')
                this.page = this.page - 1;
                this.fetch()
            },

            changeSku: function () {
                //  console.log(this.selectedProduct)
                //  console.log('change sku')

                if (this.selectedProduct > 0) {
                    this.data.sku = this.selectedProduct
                    //   this.sku(this.selectedProduct)
                }
                this.searchStatus = false
                this.selectedProduct = 0
            },

            getCountry: function () {
                let vm = this
                this.$http.get(this.$config.api + 'country').then(function (res) {
                    vm.country = res.data

                });
            }
        }
    }
</script>


<style scoped lang="scss">
    .table-product {
        tr:hover {
            cursor: pointer;
            background-color: #eaeaea;
        }

        tr.selected {
            background-color: #99bb4642;


        }
    }

    .header {
        font-size: 0.7rem;
    }

    .item {
        font-size: 0.7rem;
        cursor: pointer;
    }

    .modal-body {
        padding: 0 !important;
    }

    .modal-order {
        .modal-body {
            padding: 0 !important;
        }
    }

    .shipping {
        background-color: rgba(226, 226, 226, 0.27);
    }
</style>